import React from "react";
import PropTypes from "prop-types";

import { variants, sizes, defaults } from "./options";

import { ClockIcon } from "./Clock";
import { EmailIcon } from "./Email";
import { NewTabIcon } from "./NewTab";
import { ChevronDownIcon } from "./ChevronDownIcon";
import { LoopIcon } from "./Loop";
import { ArrowDownIcon } from "./ArrowDown";
import { CheckMarkIcon } from "./CheckMark";
import { MonitoringIcon } from "./Monitoring";
import { ShowIcon } from "./Show";
import { ChevronUpIcon } from "./ChevronUp";
import { CrossIcon } from "./Cross";
import { ObservabilityIcon } from "./Observability";
import { RestApiIcon } from "./RestApi";
import { SearchIcon } from "./SearchIcon";
import { OpenIcon } from "./Open";
import { LoggingIcon } from "./Logging";
import { CloudIcon } from "./Cloud";
import { ListIcon } from "./List";
import { ChevronLeftIcon } from "./ChevronLeft";
import { CodeIcon } from "./Code";
import { ShoppingCartIcon } from "./ShoppingCart";
import { IntermediateImplementationsIcon } from "./Implementations";
import { SadIcon } from "./Sad";
import { HappyIcon } from "./Happy";
import { EnterpriseIcon } from "./Enterprise";
import { StandardIcon } from "./Standard";
import { MessagingIcon } from "./Messaging";
import { FreeIcon } from "./Free";
import { CommunityIcon } from "./Community";
import { WindowIcon } from "./Window";
import { ExperimentsIcon } from "./Experiments";
import { CoreConceptsIcon } from "./CoreConcepts";
import { BookmarkIcon } from "./Bookmark";
import { PlayNextIcon } from "./PlayNext";
import { SecurityIcon } from "./Security";
import { PerformanceIcon } from "./Performance";
import { ArrowRightIcon } from "./ArrowRightIcon";
import { DatabaseIcon } from "./Database";
import { DataModelsIcon } from "./DataModels";
import { AnalyticsIcon } from "./Analytics";
import { ArrowLeftIcon } from "./ArrowLeft";
import { MenuIcon } from "./Menu";
import { HelpIcon } from "./Help";
import { DataHubIcon } from "./DataHub";
import { ArrowUpIcon } from "./ArrowUp";
import { ChevronRightIcon } from "./ChevronRightIcon";
import { CmsIcon } from "./Cms";
import { TutorialsIcon } from "./Tutorials";
import { StoriesIcon } from "./Stories";
import { BlogIcon } from "./Blog";
import { GraphQLIcon } from "./GraphQL";
import { ContributorIcon } from "./Contributor";
import { ImageIcon } from "./Image";
import { FavIcon } from "./Fav";
import { VideoIcon } from "./Video";
import { HasuraIcon } from "./Hasura";
import { StarIcon } from "./Star";
import { SpeechIcon } from "./Speech";
import { PlusIcon } from "./Plus";
import { MinusIcon } from "./Minus";
import { TrendingIcon } from "./Trending";
import { RecordingIcon } from "./Recording";
import { CalendarIcon } from "./Calendar";
import { DevicesIcon } from "./Devices";
import { TicketIcon } from "./Ticket";
import { EditIcon } from "./Edit";
import { CopyIcon } from "./Copy";
import { DiscussionIcon } from "./Discussion";
import { CardIcon } from "./Card";
import { LockIcon } from "./Lock";
import { HideIcon } from "./Hide";
import { MessageIcon } from "./Message";
import { ClientIcon } from "./Client";
import { AlertIcon } from "./Alert";
import { DocIcon } from "./Doc";
import { CutIcon } from "./Cut";
import { FailureIcon } from "./Failure";
import { NotificationIcon } from "./Notification";
import { ServerIcon } from "./Server";
import { QuestionIcon } from "./Question";
import { GlobeIcon } from "./Remote";
import { EquipmentIcon } from "./Equipment";
import { PTOIcon } from "./PTO";
import { Fridaycon } from "./Friday";
import { BeachIcon } from "./Beach";
import { BigStarIcon } from "./BigStar";
import { OwnershipIcon } from "./Ownership";
import { LearnIcon } from "./Learn";
import { EmpathyIcon } from "./Empathy";
import { CraftIcon } from "./Craft";
import { DiscordIcon } from "./Discord";
import { LinkedInIcon } from "./LinkedIn";
import { CommunityCallIcon } from "./CommunityCall";
import { TrophyIcon } from "./Trophy";
import { CareersIcon } from "./Careers";
import { PolygonIcon } from "./Polygon";
import { StarOneIcon } from "./StarOne";
import { GithubIcon } from "./Github";
import { PresentationIcon } from "./Presentation";
import { LaunchIcon } from "./Launch";
import { StepsIcon } from "./Steps";

const iconReferenceMap = {
  clock: ClockIcon,
  email: EmailIcon,
  open_in_new: NewTabIcon,
  chevron_down: ChevronDownIcon,
  chevron_up: ChevronUpIcon,
  chevron_left: ChevronLeftIcon,
  loop: LoopIcon,
  arrow_left: ArrowLeftIcon,
  arrow_right: ArrowRightIcon,
  arrow_up: ArrowUpIcon,
  arrow_down: ArrowDownIcon,
  check_mark: CheckMarkIcon,
  monitoring: MonitoringIcon,
  show: ShowIcon,
  cross: CrossIcon,
  observability: ObservabilityIcon,
  rest_api: RestApiIcon,
  search: SearchIcon,
  open: OpenIcon,
  logging: LoggingIcon,
  cloud: CloudIcon,
  list: ListIcon,
  code: CodeIcon,
  shopping_cart: ShoppingCartIcon,
  intermediate_implementations: IntermediateImplementationsIcon,
  sad: SadIcon,
  happy: HappyIcon,
  enterprise: EnterpriseIcon,
  standard: StandardIcon,
  community: CommunityIcon,
  free: FreeIcon,
  messaging: MessagingIcon,
  window: WindowIcon,
  experiments: ExperimentsIcon,
  core_concepts: CoreConceptsIcon,
  bookmark: BookmarkIcon,
  play_next: PlayNextIcon,
  security: SecurityIcon,
  performance: PerformanceIcon,
  database: DatabaseIcon,
  data_models: DataModelsIcon,
  analytics: AnalyticsIcon,
  menu: MenuIcon,
  chevron_right: ChevronRightIcon,
  help: HelpIcon,
  data_hub: DataHubIcon,
  cms: CmsIcon,
  tutorials: TutorialsIcon,
  stories: StoriesIcon,
  blog: BlogIcon,
  graphql: GraphQLIcon,
  contributor: ContributorIcon,
  image: ImageIcon,
  fav: FavIcon,
  video: VideoIcon,
  hasura: HasuraIcon,
  star3: StarIcon,
  speech_bubble: SpeechIcon,
  plus: PlusIcon,
  minus: MinusIcon,
  trending: TrendingIcon,
  recording: RecordingIcon,
  calendar: CalendarIcon,
  devices: DevicesIcon,
  ticket: TicketIcon,
  edit: EditIcon,
  copy: CopyIcon,
  discussion: DiscussionIcon,
  card: CardIcon,
  lock: LockIcon,
  hide: HideIcon,
  message: MessageIcon,
  client: ClientIcon,
  alert: AlertIcon,
  doc: DocIcon,
  cut: CutIcon,
  failure: FailureIcon,
  notification: NotificationIcon,
  server: ServerIcon,
  question: QuestionIcon,
  remote: GlobeIcon,
  equipment: EquipmentIcon,
  pto: PTOIcon,
  friday: Fridaycon,
  beach: BeachIcon,
  bigStar: BigStarIcon,
  ownership: OwnershipIcon,
  learn: LearnIcon,
  empathy: EmpathyIcon,
  craft: CraftIcon,
  discord: DiscordIcon,
  linkedin: LinkedInIcon,
  community_call: CommunityCallIcon,
  trophy: TrophyIcon,
  careers: CareersIcon,
  polygon: PolygonIcon,
  star1: StarOneIcon,
  github: GithubIcon,
  presentation: PresentationIcon,
  launch: LaunchIcon,
  steps: StepsIcon,
  // Default icon ~ In case dev passed wrong prop by mistake
  default: FailureIcon,
};

export const Icon = ({ size, variant, color, ...props }) => {
  const CurrentActiveIcon = iconReferenceMap[variant] || iconReferenceMap.default;

  const iconSize = sizes[size];

  const iconWidth = sizes[size]?.width || defaults.size.width;

  const iconHeight = sizes[size]?.height || defaults.size.height;

  const iconColor = variants[color]?.fill;

  return (
    <CurrentActiveIcon
      size={iconSize}
      variant={iconColor}
      iconColor={iconColor}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      minWidth={iconWidth}
      minHeight={iconHeight}
      {...props}
    />
  );
};

Icon.propTypes = {
  /**
   * Size of Icon component
   */
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl"]),
  /**
   * Color of Icon component
   */
  color: PropTypes.string,
};

Icon.defaultProps = {
  size: "sm",
  color: "sky_80",
};
